import Scenes from "../oc-threejs/Scenes";
import Textures from "../oc-threejs/Textures";
import Commons from "../oc-commons/Commons";

/**
 * @deprecated bitte APP.modelsHelper benutzen, gleiches Interface
 */
export default class Models {

    static applyToObject3d(model, object3d) {
        return APP.modelsHelper.applyToObject3d(model, object3d);
    }

    static getConnectorsFromModelRelativeToObject(model, object3d) {
        return APP.modelsHelper.getConnectorsFromModelRelativeToObject(model, object3d);
    }

    static loadModelPromise(model,materialMap=undefined) {
        return APP.modelsHelper.loadModelPromise(model,materialMap);
    }

    static setModelDataFromObject(model, object3d) {
        return APP.modelsHelper.setModelDataFromObject(model, object3d);
    }

}
